/* Rückgabe & Umtausch — GSAP entry animations */
(function () {
  function init() {
    if (typeof window.gsap === 'undefined') return setTimeout(init, 60);
    if (typeof window.ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(window.ScrollTrigger);
    }

    document.querySelectorAll('.ruckgabe-page').forEach((root) => {
      const heroEls = [
        root.querySelector('.ruckgabe-hero__label'),
        root.querySelector('.ruckgabe-hero__heading'),
        root.querySelector('.ruckgabe-hero__rule'),
        root.querySelector('.ruckgabe-hero__subtext'),
        root.querySelector('.ruckgabe-hero__aside'),
      ].filter(Boolean);

      gsap.fromTo(heroEls,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.12, delay: 0.15 }
      );

      const seal = root.querySelector('.ruckgabe-hero__seal');
      if (seal) {
        gsap.fromTo(seal,
          { rotate: -8, scale: 0.9 },
          { rotate: 0, scale: 1, duration: 1.4, ease: 'power3.out', delay: 0.5 }
        );
      }

      const reveal = (selector, opts = {}) => {
        root.querySelectorAll(selector).forEach((el) => {
          gsap.fromTo(el,
            { opacity: 0, y: 28 },
            {
              opacity: 1, y: 0, duration: 0.9, ease: 'power2.out', ...opts,
              scrollTrigger: { trigger: el, start: 'top 88%', once: true },
            }
          );
        });
      };

      reveal('.ruckgabe-policy__head > *', { stagger: 0.08 });
      reveal('.ruckgabe-policy__item', { stagger: 0.1 });
      reveal('.ruckgabe-steps__head > *', { stagger: 0.08 });
      reveal('.ruckgabe-step', { stagger: 0.12 });
      reveal('.ruckgabe-conditions__head > *', { stagger: 0.08 });
      reveal('.ruckgabe-conditions__col', { stagger: 0.12 });
      reveal('.ruckgabe-form__context > *', { stagger: 0.08 });
      reveal('.ruckgabe-form-elegant');
      reveal('.ruckgabe-closing__inner > *', { stagger: 0.1 });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
